import HowItWorks from './HowItWorks';

const HowItWorksConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/como-funciona',
            component: HowItWorks
        }
    ]
};

export default HowItWorksConfig;
